
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import runEvn from "@/modular/runEvn/RunEvn";
const fileBaseUrl = runEvn().fileBaseUrl;
export default defineComponent({
    setup() {
        const router = useRouter();
        return {
            router, //一定要要放在return里才能在模板上面使用
        };
    },
    name: "WishCardView",
    components: {},
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    computed: {
        flag() {
            if (this.data.donationType == 1) return "物资捐赠";
            if (this.data.donationType == 2) return "资金捐款";
            // if(this.data.Supplies=3)return '资金捐赠';
            return "";
        },
    },
    methods: {
        goSuppliesDetails() {
            var id = this.data.id;
            if (this.data.donationType == 1) {
                this.router.push(`/gy/donation/details/${id}`);
            } else {
                id = this.data.linkId;
                this.router.push(`/gy/wish/details/${id}`);
            }
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        goCert(){
            // this.router.push(`/gy/certificate/details/${this.data.donationCertificateId}`);
            this.router.push({
                    path: `/gy/certificate/details/${this.data.donationCertificateId}`,
                    query: {
                        isShowApply:false,
                    },
                });
        }
    },
    data() {
        return {
            xxx: 45,
        };
    },
});
